import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import AppSelect from "@AppSelects/AppSelect.vue";
import { useQualificationGroupHelper } from "@composables/masterdata/qualifications/qualificationGroups";
import { useAppInputsHelper, handlePossibleValuesFilter } from "./input_composable";
export default /*@__PURE__*/ _defineComponent({
    ...{ name: "AppSelectQualificationGroup", inheritAttrs: false },
    __name: 'AppSelectQualificationGroup',
    props: {
        modelValue: {},
        filterInput: { type: Boolean, default: false },
        dataTest: { default: "qualificationGroup" },
        inputProps: { default: () => ({}) },
        possibleValues: { default: () => [] },
        disciplineIds: { default: () => [] },
        rankedEntities: { default: () => [] }
    },
    emits: ["update:modelValue", "change", "blur"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const { masterQualificationGroups } = useQualificationGroupHelper();
        const { inputPropsCleared } = useAppInputsHelper(props);
        const inputValue = computed({
            get() {
                return props.modelValue;
            },
            set(v) {
                emits("update:modelValue", v);
            }
        });
        const groups = computed(() => {
            let groups = masterQualificationGroups.value;
            if (props.possibleValues.length) {
                groups = handlePossibleValuesFilter(groups, props.possibleValues);
            }
            if (props.disciplineIds.length) {
                groups = groups.filter(x => props.disciplineIds.includes(x.disciplineId));
            }
            if (props.rankedEntities.length) {
                groups = groups.filter(x => props.rankedEntities.includes(x.rankedEntity));
            }
            return groups;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(AppSelect, _mergeProps({
                modelValue: inputValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((inputValue).value = $event))
            }, { filterInput: _ctx.filterInput }, {
                "data-test": _ctx.dataTest,
                "input-props": {
                    label: _ctx.$t('common:qualificationGroup.label', 'Qualification group'),
                    items: groups.value,
                    itemValue: 'id',
                    itemTitle: 'name',
                    clearable: true,
                    ..._unref(inputPropsCleared)
                },
                onChange: _cache[1] || (_cache[1] = e => _ctx.$emit('change', e)),
                onBlur: _cache[2] || (_cache[2] = e => _ctx.$emit('blur', e))
            }), null, 16, ["modelValue", "data-test", "input-props"]));
        };
    }
});
